import { landing } from 'api';
import {
  LANDING_GET_CAMPAIGNS,
  LANDING_GET_CAMPAIGN_DETAIL,
  LANDING_UPDATE_CAMPAIGNS,
  LANDING_GET_STATIC_CONTENT,
  LANDING_UPDATE_STATIC_CONTENT,
  LANDING_GOTO_CONTRACT,
  LANDING_SEND_SUGGESTION,
  LANDING_PROMOCODE,
  GET_FILTERS,
  GET_UPDATE_FILTERS
} from 'store/actions/landing';
import { paginationData } from 'helpers/store';

export default {
  [LANDING_GET_CAMPAIGNS]: ({ commit }, { partnerId, groupId, idC, pagination, filter }) =>
    new Promise((resolve, reject) => {
      landing.getCampaigns(partnerId, groupId, idC, pagination, filter).then(
        resp => {
          commit(LANDING_UPDATE_CAMPAIGNS, resp.data);
          const dataHeader = paginationData(resp);
          resolve(dataHeader ? dataHeader.total : 0);
        },
        err => {
          commit('ERROR_OCCURRED', err, {
            root: true
          });
          reject();
        }
      );
    }),
  [LANDING_GET_CAMPAIGN_DETAIL]: ({ commit }, { quoteId, partnerId, groupId }) =>
    new Promise((resolve, reject) => {
      landing.getCampaignDetail(quoteId, partnerId, groupId).then(
        resp => {
          const campaignFiltered = resp.data.campaigns.filter(
            campaign =>
              campaign.campaignId.toString() === quoteId.toString() ||
              campaign.pricings?.some(
                pricing => pricing.pricingId.toString() === quoteId.toString()
              )
          );
          if (campaignFiltered.length) {
            const dataParsed = { ...resp.data };
            dataParsed.campaigns = campaignFiltered;
            commit(LANDING_UPDATE_CAMPAIGNS, dataParsed);
            resolve({ campaign: campaignFiltered[0] });
          } else {
            resolve({ error: true });
          }
        },
        err => {
          commit('ERROR_OCCURRED', err, {
            root: true
          });
          reject();
        }
      );
    }),
  [LANDING_GET_STATIC_CONTENT]: ({ commit, getters }, { partnerId }) =>
    new Promise((resolve, reject) => {
      let channelNoContract;
      const { id, channel } = getters.getPartnersNoContract;
      if (id === partnerId && channel) {
        channelNoContract = channel;
      } else {
        channelNoContract = 'ALD';
      }
      landing.getStaticContent(channelNoContract).then(
        resp => {
          commit(LANDING_UPDATE_STATIC_CONTENT, resp.data);
          resolve();
        },
        err => {
          commit('ERROR_OCCURRED', err, {
            root: true
          });
          reject();
        }
      );
    }),

  [GET_FILTERS]: ({ commit }) =>
    new Promise((resolve, reject) => {
      landing.getFilters().then(
        resp => {
          commit(GET_UPDATE_FILTERS, resp.data);
          resolve();
        },
        err => {
          commit('ERROR_OCCURRED', err, {
            root: true
          });
          reject();
        }
      );
    }),

  [LANDING_GOTO_CONTRACT]: (params, data) => {
    const CONTRACT_URL =
      data.flow === 'B2B' ? process.env.APP_B2B_CONTRACT_URL : process.env.APP_B2C_CONTRACT_URL;
    const CONTRACT_URL_PARSED =
      CONTRACT_URL.lastIndexOf('/') !== CONTRACT_URL.length - 1 ? `${CONTRACT_URL}/` : CONTRACT_URL;
    if (data.idC) {
      window.open(`${CONTRACT_URL_PARSED}${data.campaignId}/${data.partnerId}/${data.idC}`);
    } else {
      window.open(`${CONTRACT_URL_PARSED}${data.campaignId}/${data.partnerId}`);
    }
  },

  [LANDING_SEND_SUGGESTION]: (params, { suggestion, email }) =>
    new Promise((resolve, reject) => {
      landing.sendSuggestion(suggestion, email).then(
        resp => {
          resolve(resp);
        },
        err => {
          reject(err);
        }
      );
    }),

  [LANDING_PROMOCODE]: (params, data) => {
    const APP_PROMOCODE_URL =
      process.env.APP_PROMOCODE_URL.lastIndexOf('/') !== process.env.APP_PROMOCODE_URL.length - 1
        ? `${process.env.APP_PROMOCODE_URL}/`
        : process.env.APP_PROMOCODE_URL;
    window.location.href = `${APP_PROMOCODE_URL}${data.promocode}`;
  }
};
